<template>
    <div>
      <Pos_invoices_tax_refund_detail/>
    </div>
  </template>
  
  <script>
  import Pos_invoices_tax_refund_detail from "@/components/adminArin/pos_system/pos/Pos_invoices_tax_refund_detail";
  export default {
    name: "PosInvoicesTaxRefundDetail",
    components: {
      Pos_invoices_tax_refund_detail
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  